﻿(function () {
  const DATA_SELECTOR = '[data-mkz-auto-recommendations]';
  let dataPromise = null;
  let initTimer = null;

  function money(cents) {
    const value = Math.round(Number(cents || 0) / 100);
    return `Rs.&nbsp;${value.toLocaleString('en-IN')}`;
  }

  function getSourceUrl(root) {
    return root?.dataset.source || window.mkzRecommendationDataUrl || '';
  }

  function loadData(source) {
    if (!source) return Promise.resolve(null);
    if (!dataPromise) {
      dataPromise = fetch(source, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
    }
    return dataPromise;
  }

  function isAvailableProduct(product) {
    if (!product?.available || !product.variant_id) return false;
    const tracksInventory = product.inventory_management !== null && product.inventory_management !== undefined && product.inventory_management !== '';
    if (!tracksInventory) return true;
    return Number(product.inventory_quantity || 0) > 0;
  }

  function isAvailableHandle(data, handle) {
    return isAvailableProduct(data?.products?.[handle]);
  }

  function productFamily(data, handle) {
    return data?.products?.[handle]?.family || handle;
  }

  function productCard(product, context) {
    const compare =
      product.compare_at_price && product.compare_at_price > product.price
        ? `<span class="mkz-auto-rec__compare">${money(product.compare_at_price)}</span>`
        : '';
    const discount =
      product.compare_at_price && product.compare_at_price > product.price
        ? Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100)
        : 0;
    const badge = discount ? `<span class="mkz-auto-rec__badge">-${discount}%</span>` : '';
    const addButton =
      context === 'cart' && isAvailableProduct(product)
        ? `<button type="button" class="mkz-auto-rec__add" data-mkz-upsell-add="${product.variant_id}">+ Add</button>`
        : '';

    return `
      <article class="mkz-auto-rec__card">
        <a class="mkz-auto-rec__media" href="${product.url}">
          ${badge}
          <img src="${product.image}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy">
        </a>
        <div class="mkz-auto-rec__body">
          <a class="mkz-auto-rec__title" href="${product.url}">${product.title}</a>
          <div class="mkz-auto-rec__price">
            <span>${money(product.price)}</span>
            ${compare}
          </div>
          ${addButton}
        </div>
      </article>
    `;
  }

  function uniquePush(list, value) {
    if (value && !list.includes(value)) list.push(value);
  }

  function handlesForProduct(data, handle, type, limit) {
    const picked = [];
    const excludedFamilies = new Set([productFamily(data, handle)]);
    const configured = data?.recommendations?.[handle]?.[type] || [];
    configured.concat(data?.fallbacks?.[type] || []).forEach((item) => {
      const family = productFamily(data, item);
      if (item !== handle && isAvailableHandle(data, item) && !excludedFamilies.has(family)) {
        uniquePush(picked, item);
        excludedFamilies.add(family);
      }
    });
    return picked.slice(0, limit);
  }

  function render(root, handles, data, context) {
    const track = root.querySelector('[data-mkz-auto-recommendations-track]');
    if (!track) return;
    const products = handles.map((handle) => data.products?.[handle]).filter(isAvailableProduct);
    if (!products.length) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    track.innerHTML = products.map((product) => productCard(product, context)).join('');
  }

  function initProduct(root, data) {
    const handle = root.dataset.productHandle;
    const limit = Number(root.dataset.limit || 4);
    render(root, handlesForProduct(data, handle, 'related', limit), data, 'product');
  }

  async function initCart(root, data) {
    const limit = Number(root.dataset.limit || 4);
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json());
    const cartHandles = (cart.items || []).map((item) => item.handle).filter(Boolean);
    const excludedFamilies = new Set(cartHandles.map((handle) => productFamily(data, handle)));
    const handles = [];
    cartHandles.forEach((handle) => {
      (data?.recommendations?.[handle]?.upsell || []).forEach((candidate) => {
        const family = productFamily(data, candidate);
        if (!cartHandles.includes(candidate) && isAvailableHandle(data, candidate) && !excludedFamilies.has(family)) {
          uniquePush(handles, candidate);
          excludedFamilies.add(family);
        }
      });
    });
    (data?.fallbacks?.upsell || []).forEach((candidate) => {
      const family = productFamily(data, candidate);
      if (!cartHandles.includes(candidate) && isAvailableHandle(data, candidate) && !excludedFamilies.has(family)) {
        uniquePush(handles, candidate);
        excludedFamilies.add(family);
      }
    });
    render(root, handles.slice(0, limit), data, 'cart');
  }

  function refreshCartSections() {
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((item) => item.dataset.sectionId)
      .filter(Boolean);
    if (!sectionIds.length) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }
    fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((sections) => {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { sections }, source: 'mkz-auto-recommendations' },
          })
        );
      })
      .catch(() => window.location.reload());
  }

  function bindAddButtons(scope) {
    scope.querySelectorAll('[data-mkz-upsell-add]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        button.disabled = true;
        button.textContent = 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(button.dataset.mkzUpsellAdd), quantity: 1 }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Add failed');
            refreshCartSections();
          })
          .catch(() => {
            button.disabled = false;
            button.textContent = '+ Add';
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll(DATA_SELECTOR).forEach((root) => {
      loadData(getSourceUrl(root)).then((data) => {
        if (!data?.products) return;
        if (root.dataset.context === 'cart') {
          initCart(root, data).then(() => bindAddButtons(root));
        } else {
          initProduct(root, data);
        }
      });
    });
  }

  function scheduleInitAll(delay = 120) {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(initAll, delay);
  }

  function nodeHasRecommendations(node) {
    return (
      node?.nodeType === 1 &&
      (node.matches?.(DATA_SELECTOR) || node.querySelector?.(DATA_SELECTOR))
    );
  }

  document.addEventListener('DOMContentLoaded', () => scheduleInitAll(0));
  window.addEventListener('load', () => scheduleInitAll(0));
  document.addEventListener('cart:update', () => scheduleInitAll(0));
  document.addEventListener('cart:refresh', () => scheduleInitAll(0));
  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target?.closest?.(
          'cart-drawer-component button, .cart-drawer__close-button, [aria-label*="cart" i], [aria-label*="Cart" i]'
        )
      ) {
        scheduleInitAll(180);
      }
    },
    true
  );

  if (document.body) {
    new MutationObserver((mutations) => {
      if (
        mutations.some((mutation) =>
          Array.from(mutation.addedNodes || []).some((node) => nodeHasRecommendations(node))
        )
      ) {
        scheduleInitAll(80);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
